export default [
  { label: 'BS/MD Applicant', value: 'bd' },
  { label: 'Art Portfolio Applicant', value: 'art' },
  { label: 'Recruited College Athlete', value: 'athlete' },
  { label: 'ADA Accommodations', value: 'ada' },
  { label: 'Other', value: 'other' },
];
